export { default } from './PartiuGpCalendario';
